import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-slate-800 bg-slate-950 px-5 py-10 text-white/85" data-id="element-79" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-[680px] text-center text-[0.85rem] leading-relaxed" data-id="element-80" data-mp="3ggtxgg3gzf46">
        <p data-id="element-81" data-mp="32p5qssbzpiul">
          © {new Date().getFullYear()} FINANCIAL LITERACY READY™. All rights
          reserved. Digital educational product intended for teachers and
          education professionals. Classroom experience and results may vary
          depending on school context, student needs, pacing, and
          implementation.
        </p>
      </div>
    </footer>;
}